import { render, staticRenderFns } from "./OrderComponent.vue?vue&type=template&id=f026eaa4&scoped=true&"
import script from "./OrderComponent.vue?vue&type=script&lang=js&"
export * from "./OrderComponent.vue?vue&type=script&lang=js&"
import style0 from "./OrderComponent.vue?vue&type=style&index=0&id=f026eaa4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f026eaa4",
  null
  
)

export default component.exports